import {BaseContainerModel} from '../base-container.model';
import {
  bl_fi_generic_doc_single_line,
} from '../../dbschema/index';

export class  GenericDocSingleLineContainer extends BaseContainerModel {
  bl_fi_generic_doc_single_line: bl_fi_generic_doc_single_line = new bl_fi_generic_doc_single_line();
}  


